import React from 'react'
import { modals } from '@mantine/modals'
import { Image, Box, Text } from '@mantine/core'
import { notificationSuccess, notificationError } from '../Notifications'
import SearchMascot from '../../../assets/img/mascot/18.png'

export const modalRestoreUser = ( title, payload, name, functionRestore, reloadData ) => {

  const handleRestoreData = async (payload) => {
    try {
      const response = await functionRestore(payload)
      if (response.success) {
        notificationSuccess(`Restore ${title} successfully`,  `Data ${title} successfully restored`)
        reloadData()
        modals.closeAll()
      }
    } catch (error) {
      console.log(error)
      notificationError(`Restore ${title} error`, `Cannot restored data ${title}`)
    }
  }

  return modals.openConfirmModal({
    centered: 'true',
    closeOnConfirm: false,
    withCloseButton: false,
    size: 'lg',
    children: (
      <Box>
        <Box ta='center'>
          <Image src={SearchMascot} fit='contain' h='180' my={20} />
          <Text fw={500} mb={4}>Are you sure you want to Restore this User ? </Text>
          <Text fw='bold' mb={14}>"{name}"</Text>
        </Box>
      </Box>
    ),
    labels: { confirm: 'Restore Now', cancel: "Cancel" },
    confirmProps: { color: 'red' },
    onConfirm: () => handleRestoreData(payload),
  })
}
